<template>
  <div>
    <div>
      <b-form-input
        placeholder="Buscar por nombre o código"
        v-model="criterion"
        class="mb-4"
      >
      </b-form-input>
    </div>
    <b-table
      sticky-header
      hover
      small
      responsive="md"
      :items="list"
      :fields="fields"
      :per-page="cantidadRequest"
      striped
    >
      <!-- :variant="ESTATUS['Inactivo'].color" -->
      <template #cell(id)="data">
        <span class="text-primary">{{ data.item }}</span>
      </template>
      <template #cell(name)="data">
        <span>{{ data.item.nombre }} {{ data.item.apellido }}</span>
      </template>
      <template #cell(code)="data">
        <span>{{ data.item.codigo }} </span>
      </template>
      <template #cell(status)="data">
        <b-badge
          class="p-2"
          :variant="
            ESTATUS[data.item.lockupEnabled ? 'Activo' : 'Inactivo'].color
          "
          >{{ data.item.lockupEnabled ? "Activo" : "Inactivo" }}</b-badge
        >
      </template>
      <template #cell(input)="data">
        <template v-if="$store.state.login.user.id != data.item.id">
          <b-button
            v-if="data.item.lockupEnabled"
            size="sm"
            variant="danger"
            @click="changeStatus(data.item)"
          >
            Inactivar</b-button
          >
          <b-button
            v-else
            size="sm"
            variant="success"
            @click="changeStatus(data.item)"
          >
            Activar</b-button
          >
        </template>
      </template>
    </b-table>

    <b-pagination
      :total-rows="cantidad"
      v-model="currentPage"
      first-number
      last-number
      align="right"
      prev-class="prev-item"
      next-class="next-item"
      :per-page="cantidadRequest"
    />
  </div>
</template>
<script>
import { mapState } from "vuex";
import { ESTATUS } from "../../utils/constants";

export default {
  data() {
    return {
      fields: [
        { key: "name", label: "Nombre y apellido" },
        { key: "code", label: "Código de empleado" },
        { key: "status", label: "Estado" },
        { key: "rol", label: "rol" },
        { key: "input", label: "" },
      ],
      criterion: "",
      ESTATUS: ESTATUS,
    };
  },
  async mounted() {
    await this.getList();
  },
  methods: {
    async getList() {
      await this.$store.dispatch({
        type: "user/getUsers",
        data: this.request,
      });
    },

    async changeStatus(item) {
      await this.$store
        .dispatch({
          type: "user/changeStatus",
          data: { id: item.id, locked: !item.lockupEnabled },
        })
        .then(async (resp) => {
          this.$swal.fire("Éxito", `${resp.message}`, "success");
          await this.getList();
        })
        .catch((e) => {
          this.$swal.fire("Error", `${e.message}`, "error");
        });
    },
  },
  computed: {
    ...mapState({
      list: (state) => state.user.response.listEmpleados,
      cantidad: (state) => state.user.response.cantidad,
      request: (state) => state.user.request,
      cantidadRequest: (state) => state.user.request.cantidad,
    }),
    currentPage: {
      get: function() {
        return this.$store.state.user.request.skip;
      },
      set: async function(value) {
        this.$store.commit("user/SET_SKIP", value);
        await this.getList();
      },
    },
  },
  watch: {
    async criterion(value) {
      this.$store.commit("user/SET_CRITERIO", value);
      await this.getList();
    },
  },
};
</script>
<style scoped></style>
